var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12578 9.58551C5.74157 9.77762 5.27438 9.62189 5.08228 9.23768C4.89018 8.85348 5.04591 8.38629 5.43011 8.19419L11.6523 5.08309C11.8713 4.97361 12.129 4.97361 12.348 5.08309L18.5702 8.19419C18.9544 8.38629 19.1101 8.85348 18.918 9.23768C18.7259 9.62189 18.2587 9.77762 17.8745 9.58551L12.0001 6.64833L6.12578 9.58551ZM11.47 8.24047C11.803 8.07065 12.1972 8.07066 12.5301 8.24047L16.8079 10.4221C17.1986 10.6214 17.4445 11.0229 17.4445 11.4614V16.6676C17.4445 17.9563 16.3998 19.001 15.1112 19.001H14.4419C13.9524 19.001 13.5556 18.6042 13.5556 18.1147V15.8899C13.5556 15.0308 12.8592 14.3343 12.0001 14.3343C11.141 14.3343 10.4445 15.0308 10.4445 15.8899V18.1147C10.4445 18.6042 10.0477 19.001 9.55824 19.001H8.88899C7.60033 19.001 6.55566 17.9563 6.55566 16.6676V11.4614C6.55566 11.0229 6.8016 10.6214 7.19228 10.4221L11.47 8.24047Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d58efdee4461d6a01a586ad1dbcd28cf.svg";
export { ForwardRef as ReactComponent };